@if (eventWidth(); as width) {
    <div
        [cdkContextMenuTriggerFor]="contextMenu"
        (cdkContextMenuOpened)="isContextOpen.set(true)"
        (cdkContextMenuClosed)="isContextOpen.set(false)"
        [style.width]="width + 'px'"
        class="calendar-event-wrapper"
        [class.start-has-prev-week]="startHasPrevWeek()"
    >
        @if (event(); as event) {
            <div class="relative">
                <div
                    class="prefix"
                    [class.start-has-prev-week]="startHasPrevWeek()"
                    [attr.data-all-day]="event.allDay"
                    [attr.data-color]="event?.color"
                    [class.active]="isContextOpen()"
                ></div>
                <div
                    [class.disabled]="!options()?.event?.resize"
                    [dndDisableIf]="!options()?.event?.resize"
                    [dndDraggable]="{ event, type: 'resize', date: 'start' }"
                    class="resizer-left"
                ></div>
                <div
                    eventContent
                    [event]="event"
                    [width]="eventWidth()"
                    dndDraggingClass="active"
                    [dndDraggable]="{ event, type: 'drop' }"
                    [dndDisableIf]="!options()?.event?.drop"
                    [class.active]="isContextOpen()"
                    [class.start-has-prev-week]="startHasPrevWeek()"
                    [attr.data-color]="event?.color"
                    [attr.data-all-day]="event.allDay"
                    [attr.data-start]="event.startDate"
                    [attr.data-end]="event.endDate"
                    [attr.data-week-index]="weekIndex()"
                    class="calendar-event"
                ></div>
                <div
                    [class.disabled]="!options()?.event?.resize"
                    [dndDisableIf]="!options()?.event?.resize"
                    [dndDraggable]="{ event, type: 'resize', date: 'end' }"
                    class="resizer-right"
                ></div>
            </div>
        }
    </div>
}

<ng-template #contextMenu>
    <app-menu cdkMenu>
        @for (option of menus; track $index) {
            <app-menu-option (click)="menu.emit(option.value)" cdkMenuItem [icon]="option.icon">{{ option.label }}</app-menu-option>
        }
    </app-menu>
</ng-template>
